import React, { useState } from "react"
import { Link } from "react-router-dom"
import { MdNotificationsActive } from "react-icons/md"
import { useAuth0 } from "@auth0/auth0-react"
import AskAnythingChat from "./components/CsrdBenchmarking/AskAnythingChat"
import DashboardPanel from "./components/CsrdBenchmarking/DashboardPanel"

const AUTH_KEYS = [
  "JWT", "userName", "organization", "loginType", "companyid", "companyName", "features",
  "legal1", "business1", "country1", "site1", "year1",
  "scope2legal", "scope2business", "scope2country", "scope2site", "scope2supplier", "scope2year",
  "businessTravelLegal", "businessTravelBusiness", "businessTravelCountry", "businessTravelSite", "businessTravelYear",
  "transportlegal", "transportbusiness", "transportcountry", "transportsite", "transportyear",
  "sbusiness", "scountry", "sjob", "slegal", "ssite", "syear",
  "allconfig", "report", "reportStatusData", "report_name",
  "savedReports", "savedStatus", "savedSurveys",
  "brsr_report_id", "brsr_sectionA_data", "brsrSectionCPopup",
  "step1", "step2", "step2Draft", "step3", "step4",
  "answers", "answers1", "answers2", "tableAnswers",
  "selectedOptions", "csrd", "type", "mdrp", "e1", "s1",
  "scfFormInProgress", "scfStep1", "scfStep2",
  "editFieldMapping", "popup1", "popup2", "popup3",
  "bloburl", "logo", "hash", "linkToken", "linkUrl",
  "weblink", "statusDashboardUrl", "statusReportFile",
  "oldp", "redirectAfterLogin",
]

const DATASET_OPTIONS = [
  { key: "csrd", label: "CSRD", description: "European CSRD reporters" },
  { key: "nifty", label: "BRSR / Nifty", description: "Indian ESG reporters" },
  { key: "all", label: "All Markets", description: "Cross-market view" },
]

const DatasetToggle = ({ value, onChange }) => (
  <div style={{ display: "flex", gap: "2px", backgroundColor: "#F0F0F0", borderRadius: "8px", padding: "3px" }}>
    {DATASET_OPTIONS.map((opt) => (
      <button
        key={opt.key}
        onClick={() => onChange(opt.key)}
        title={opt.description}
        style={{
          padding: "5px 14px",
          borderRadius: "6px",
          border: "none",
          fontSize: "12px",
          fontWeight: value === opt.key ? "600" : "400",
          color: value === opt.key ? "#fff" : "#494949",
          backgroundColor: value === opt.key ? "#407775" : "transparent",
          cursor: "pointer",
          transition: "all 0.15s",
          whiteSpace: "nowrap",
        }}
      >
        {opt.label}
      </button>
    ))}
  </div>
)

const CsrdBenchmarkingV2 = () => {
  const { logout } = useAuth0()
  const [isOpen, setIsOpen] = useState(false)
  const username = localStorage.getItem("userName")
  const handleLogout = () => {
    AUTH_KEYS.forEach(k => localStorage.removeItem(k))
    logout({ logoutParams: { returnTo: window.location.origin } })
  }

  const [companyContext, setCompanyContext] = useState(null)
  const [selectedYear, setSelectedYear] = useState(null)
  const [dataset, setDataset] = useState("csrd")

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      {/* Top nav bar */}
      <header>
        <nav
          style={{
            backgroundColor: "#407775",
            padding: "8px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <a href="#home">
              <img src="assets/img/logo.png" alt="EcoPrism" height="28" />
            </a>
            <div
              style={{
                borderLeft: "1px solid rgba(255,255,255,0.3)",
                height: "24px",
              }}
            />
            <span style={{ color: "rgba(255,255,255,0.7)", fontSize: "13px" }}>
              ESG Benchmarking Intelligence
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <a href="#notifications" style={{ color: "#fff" }}>
              <MdNotificationsActive size={20} />
            </a>
            <span style={{ color: "rgba(255,255,255,0.7)", fontSize: "14px" }}>{username}</span>
            <div style={{ position: "relative" }}>
              <a href="#" style={{ color: "#fff" }} onClick={(e) => { e.preventDefault(); setIsOpen(!isOpen); }}>
                <img src="assets/img/User.png" alt="User" style={{ width: "24px", height: "24px" }} />
              </a>
              {isOpen && (
                <ul className="dropdown-menu show" style={{ position: "absolute", right: 0, top: "100%", zIndex: 9999, minWidth: "160px", overflow: "hidden", borderRadius: "4px" }}>
                  <li><button onMouseEnter={e => { e.currentTarget.style.background = "#407775"; e.currentTarget.style.color = "#fff"; }} onMouseLeave={e => { e.currentTarget.style.background = "none"; e.currentTarget.style.color = "#212529"; }} style={{ color: "#212529", background: "none", border: "none", width: "100%", textAlign: "left", padding: "6px 16px", cursor: "pointer" }} onClick={handleLogout}>Logout</button></li>
                </ul>
              )}
            </div>
          </div>
        </nav>
      </header>

      {/* Breadcrumb + Dataset Toggle */}
      <div
        style={{
          padding: "8px 24px",
          borderBottom: "1px solid #E5E5E5",
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexShrink: 0,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Link to="/esg-benchmarking" style={{ color: "#407775", fontSize: "12px", textDecoration: "none" }}>
            Home
          </Link>
          <span style={{ color: "#707070", fontSize: "12px" }}>{">"}</span>
          <span style={{ color: "#707070", fontSize: "12px" }}>ESG Benchmarking</span>
        </div>
        <DatasetToggle value={dataset} onChange={setDataset} />
      </div>

      {/* Main split layout */}
      <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>
        {/* Left panel — Ask Anything Chat */}
        <div
          style={{
            width: "35%",
            minWidth: "340px",
            maxWidth: "480px",
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <AskAnythingChat companyContext={companyContext} selectedYear={selectedYear} dataset={dataset} />
        </div>

        {/* Right panel — Dashboard */}
        <div style={{ flex: 1, overflow: "hidden" }}>
          <DashboardPanel
            dataset={dataset}
            onCompanyChange={setCompanyContext}
            onYearChange={setSelectedYear}
          />
        </div>
      </div>
    </div>
  )
}

export default CsrdBenchmarkingV2
